import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from 'auth/AuthProvider'
import { reqAddDeliveryAddress, reqRemoveDeliveryAddress } from 'client/ClientRequests'
import { IDeliveryAddress } from 'client/IClientInfo'
import BlueButton from 'components/inputs/BlueButton'
import React, { useCallback, useState } from 'react'
import DeliveryAddressForm from './DeliveryAddressForm'
import DeliveryAddressListItem from './DeliveryAddressListItem'

const DeliveryAddressList: React.FC = () => {
  const auth = useAuth()
  const [addresses, setAddresses] = useState<IDeliveryAddress[]>(
    auth.user?.addresses || []
  )
  const [isAddingAddress, setIsAddingAddress] = useState(false)

  const handelCreateAddress = useCallback(
    (address: IDeliveryAddress) => {
      reqAddDeliveryAddress(address, (newAddress) => {
        if (newAddress) {
          setIsAddingAddress(false)

          const newAddresses = [...addresses, newAddress]
          setAddresses(newAddresses)
          if (auth.user) {
            auth.user.addresses = newAddresses
          }
        }
      })
    },
    [auth, addresses]
  )

  const handelRemoveAddress = useCallback(
    (address: IDeliveryAddress) => {
      reqRemoveDeliveryAddress(address.deliv_addr_id, (response) => {
        if (response.status === 'OK') {
          const newAddresses = addresses.filter(
            (addr) => addr.deliv_addr_id !== address.deliv_addr_id
          )
          setAddresses(newAddresses)
          if (auth.user) {
            auth.user.addresses = newAddresses
          }
        }
      })
    },
    [auth, addresses]
  )

  return (
    <div className='px-3'>
      {addresses.map((address) => (
        <DeliveryAddressListItem
          key={address.deliv_addr_id}
          address={address}
          onRemove={handelRemoveAddress}
          hideRemoveButton={addresses.length <= 1}
        />
      ))}

      {isAddingAddress ? (
        <div className='pl-dynamic' style={{ maxWidth: '700px' }}>
          <DeliveryAddressForm
            address={null}
            onAccept={handelCreateAddress}
            onCancel={() => setIsAddingAddress(false)}
          />
        </div>
      ) : (
        <BlueButton className='mt-2' onClick={() => setIsAddingAddress(true)}>
          <FontAwesomeIcon icon={faPlus} /> Добавить адрес
        </BlueButton>
      )}
    </div>
  )
}
export default DeliveryAddressList
